export default "__VITE_ASSET__Di5ixOZ6__"